
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface CaptureModeProps {
  selectedMode: string;
  onModeChange: (mode: string) => void;
}

export const CaptureMode = ({ selectedMode, onModeChange }: CaptureModeProps) => {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold text-gray-900">{t('capture_mode')}</h2>
      <p className="text-sm text-gray-600">
        {t('capture_mode_description')}
      </p>
      <RadioGroup value={selectedMode} onValueChange={onModeChange} className="space-y-3">
        <div className="flex items-center space-x-3">
          <RadioGroupItem value="mic" id="microphone-capture" />
          <Label htmlFor="microphone-capture" className="text-sm font-medium">
            {t('microphone_capture')}
          </Label>
        </div>
      </RadioGroup>
    </div>
  );
};
